import React from "react";
import { OneTimeSlot } from "../../api/scheduleApi.ts";
import OneTimeSlotsForm from "./OneTimeSlotsForm.tsx";
import OneTimeSlotsList from "./OneTimeSlotsList.tsx";
import { LocationWithName } from "../../api/locationApi.ts";
import { Trans } from "@lingui/react/macro";
import InfoBox from "../util/InfoBox.tsx";

interface OneTimeSlotsFormProps {
  onAddOneTimeSlot: (oneTimeSlot: OneTimeSlot) => void;
  onDeleteOneTimeSlot: (id: string) => void;
  existingOneTimeSlots: OneTimeSlot[];
  isLoading: boolean;
  deletingId: string | null;
  onSelectLocation: (location: LocationWithName) => void;
  selectedLocation: LocationWithName;
  locations: LocationWithName[];
}

const OneTimeSlotsSettings: React.FC<OneTimeSlotsFormProps> = ({
  onAddOneTimeSlot,
  onDeleteOneTimeSlot,
  existingOneTimeSlots,
  isLoading,
  deletingId,
  onSelectLocation,
  selectedLocation,
  locations,
}) => {
  return (
    <>
      <InfoBox variant={"info"} className={"mb-4"}>
        <Trans>
          A one time slot is a time slot where you are offering lessons outside
          of your normal schedule.
        </Trans>
      </InfoBox>
      <OneTimeSlotsForm
        onAddOneTimeSlot={onAddOneTimeSlot}
        existingOneTimeSlots={existingOneTimeSlots}
        isLoading={isLoading}
        locations={locations}
        onSelectLocation={onSelectLocation}
        selectedLocation={selectedLocation}
      />
      <OneTimeSlotsList
        oneTimeSlots={existingOneTimeSlots}
        onDeleteOneTimeSlot={onDeleteOneTimeSlot}
        deletingId={deletingId}
        locations={locations}
      />
    </>
  );
};

export default OneTimeSlotsSettings;
